import { render, staticRenderFns } from "./AlbumHome.vue?vue&type=template&id=4a283782&scoped=true&"
import script from "./AlbumHome.vue?vue&type=script&lang=js&"
export * from "./AlbumHome.vue?vue&type=script&lang=js&"
import style0 from "./AlbumHome.vue?vue&type=style&index=0&id=4a283782&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a283782",
  null
  
)

component.options.__file = "AlbumHome.vue"
export default component.exports